const isDigit = character => character == parseInt(character) && !isNaN(character);

export default isDigit;
